import { Button as DevButton } from 'devextreme-react/button';
import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { phanBoPhiApi } from "../../../api/phanBoPhiApi";
import { showNotify } from "../../../helpers/toast";
import { ts_hocsinh } from "../../../models/response/hocsinh/ts_hocsinh";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { RootState } from '../../../state/reducers';
import { DefaultConfirm } from "../../confirm";
import SendBienLaiModal from '../send-bien-lai/SendBienLaiModal';

type ThuPhiFinishConfirmBtnProps = {
    disabled: boolean,
    sf_mucphaithu: sf_mucphaithu,
    ts_hocsinh: ts_hocsinh,
    onChanged: () => void,
    ngaythu: any,
    nam_hoc_dong_phi: string
}

const ThuPhiFinishConfirmBtn = (props: ThuPhiFinishConfirmBtnProps) => {
    const state = useSelector((x: RootState) => x.thuPhiChiTiet)
    const {
        sf_phanbophis
    } = state;
    const [isShowPopUp, setIsShowPopUp] = useState<boolean>(false)
    const [isShowSendEmailModal, setIsShowSendEmailModal] = useState<boolean>(false)
    const [isShowConfirmSendEmailModal, setIsShowConfirmSendEmailModal] = useState<boolean>(false)
    const is_chuyenkhoan = sf_phanbophis !== undefined && sf_phanbophis !== null && sf_phanbophis.length > 0 && sf_phanbophis[0].hinh_thuc_thanh_toan.toUpperCase().includes("CHUYỂN KHOẢN");
    return (
        <>
            <DevButton
                text="Lưu"
                type="normal"
                stylingMode="text"
                icon="todo"
                className="p-btn-devextreme"
                disabled={props.disabled}
                onClick={() => {
                    setIsShowPopUp(true)
                }}
            />
            {isShowPopUp &&
                <ConfirmFinish
                    onClose={() => {
                        setIsShowPopUp(false)
                    }}
                    onChanged={() => {
                        setIsShowPopUp(false);
                        props.onChanged()
                        if (is_chuyenkhoan) {
                            setIsShowConfirmSendEmailModal(true)
                        }
                    }}
                    sf_mucphaithu={props.sf_mucphaithu}
                    ngaythu={props.ngaythu}
                    nam_hoc_dong_phi={props.nam_hoc_dong_phi}
                />
            }
            {isShowConfirmSendEmailModal && <ConfirmSendMail
                onClose={() => {
                    setIsShowConfirmSendEmailModal(false)
                }}
                onConfirmed={() => {
                    setIsShowConfirmSendEmailModal(false)
                    setIsShowSendEmailModal(true);
                }}
            />
            }
            {isShowSendEmailModal && is_chuyenkhoan &&
                <SendBienLaiModal
                    onClose={() => {
                        setIsShowSendEmailModal(false);
                    }}
                    sf_mucphaithu={props.sf_mucphaithu}
                    ts_hocsinh_id={props.ts_hocsinh.id}
                />
            }

        </>
    )
}
type ConfirmFinishProps = {
    onClose: () => void,
    onChanged: () => void,
    sf_mucphaithu: sf_mucphaithu
    ngaythu: Date,
    nam_hoc_dong_phi: string
}
type ConfirmSendMailProps = {
    onClose: () => void,
    onConfirmed: () => void
}
const ConfirmSendMail = (props: ConfirmSendMailProps) => {
    return (
        <DefaultConfirm
            onClose={() => { props.onClose() }}
            onConfirmed={() => { props.onConfirmed() }}
            text={`Bạn có muốn gửi email thông báo phí cho phụ huynh không?`}
            type="success"
            text_close_button="Đóng"
            text_confirm_button="Xác nhận"
        />

    )
}
const ConfirmFinish = (props: ConfirmFinishProps) => {
    const [isSaving, SetIsSaving] = useState<boolean>(false);
    const handleSubmit = async () => {
        SetIsSaving(true)
        const res = await phanBoPhiApi.save_finish(props.sf_mucphaithu.id, props.ngaythu, props.nam_hoc_dong_phi);
        if (res.is_success) {
            showNotify({ message: "Thành công", type: "success" });
            props.onChanged()
        } else {
            showNotify({ message: res.message || "Thất bại", type: "error" });
        }
        SetIsSaving(false)
    }
    return (
        <DefaultConfirm
            onClose={() => { props.onClose() }}
            onConfirmed={handleSubmit}
            text={`Hoàn thành thu phí vào tạo biên lai cho chứng từ ${props.sf_mucphaithu.so_chung_tu}`}
            type="success"
            text_close_button="Đóng"
            text_confirm_button="Tạo biên lai"
            is_saving={isSaving}
        />
    )
}
export default ThuPhiFinishConfirmBtn